import { Controller } from "@hotwired/stimulus"

// Makes a whole table row clickable: a click anywhere on the row triggers the row's
// primary link, which carries its own Turbo semantics (offcanvas stream, _top navigation).
//
// Left alone: real interactive elements, anything opting out with [data-row-link-ignore],
// and a click that ends a text selection. Whatever ships click-to-edit adds its own marker
// here — until something actually handles the click, ignoring a cell only makes it a dead
// zone on a row that still looks clickable.
const IGNORE = "a, button, input, label, select, textarea, dialog, [data-row-link-ignore]"

export default class extends Controller {
  static targets = ["link"]

  navigate(event) {
    if (!this.hasLinkTarget) return
    if (event.target !== this.element && event.target.closest(IGNORE)) return
    if (event.type === "click" && window.getSelection()?.toString()) return
    // auxclick fires for every non-primary button; only the middle one means "new tab".
    if (event.type === "auxclick" && event.button !== 1) return

    const newTab = event.type === "auxclick" || event.metaKey || event.ctrlKey || event.shiftKey

    if (newTab) {
      window.open(this.linkTarget.href, "_blank", "noopener")
    } else {
      this.linkTarget.click()
    }
  }
}
